import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPieChart, FiTwitter, FiLinkedin, FiGithub } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-slate-50 pt-20 pb-10 border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-brand-600 p-2 rounded-lg text-white">
                <SafeIcon icon={FiPieChart} className="w-5 h-5" />
              </div>
              <span className="font-bold text-xl tracking-tight text-slate-900">MyEPF</span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed mb-6">
              Empowering Malaysian workers with better financial visualization tools. Not affiliated with KWSP.
            </p>
            <div className="flex gap-4">
              {[FiTwitter, FiLinkedin, FiGithub].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-400 hover:text-brand-600 hover:border-brand-200 transition-all">
                  <SafeIcon icon={Icon} className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-bold text-slate-900 mb-6">Product</h4>
            <ul className="space-y-4 text-sm font-medium text-slate-500">
              <li><a href="#calculator" className="hover:text-brand-600">Calculator</a></li>
              <li><a href="#features" className="hover:text-brand-600">Features</a></li>
              <li><a href="#how-it-works" className="hover:text-brand-600">Methodology</a></li>
              <li><a href="#ai-advisor" className="hover:text-brand-600">AI Advisor</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-slate-900 mb-6">Resources</h4>
            <ul className="space-y-4 text-sm font-medium text-slate-500">
              <li><a href="#" className="hover:text-brand-600">EPF Guide 2024</a></li>
              <li><a href="#" className="hover:text-brand-600">Tax Relief Tips</a></li>
              <li><a href="#" className="hover:text-brand-600">Housing Withdrawals</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-slate-900 mb-6">Legal</h4>
            <ul className="space-y-4 text-sm font-medium text-slate-500">
              <li><a href="#" className="hover:text-brand-600">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-brand-600">Terms of Service</a></li>
              <li><a href="#" className="hover:text-brand-600">Disclaimer</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-semibold text-slate-400 uppercase tracking-widest">
          <p>&copy; {new Date().getFullYear()} MyEPF.COM. All rights reserved.</p>
          <p>Made with ❤️ for the Malaysian Workforce</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;